<template>
  <router-link v-if="tag == 'router-link'" tag="a" :to="href">
    <div class="item" @mouseenter="hovered = true" @mouseleave="hovered = false">
      <img :src="hovered ? imageActive : image" :alt="name" />
      <div v-if="hovered" class="name">{{ name }}</div>
    </div>
  </router-link>

  <a v-else :href="href">
    <div class="item" @mouseenter="hovered = true" @mouseleave="hovered = false">
      <img :src="hovered ? imageActive : image" :alt="name" />
      <div v-if="hovered" class="name">{{ name }}</div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true,
    },
    imageActive: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: "router-link",
    },
  },
  data() {
    return {
      hovered: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.item {
  height: 3.5rem;
  width: 3.5rem;
  margin-bottom: 1.54rem;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border-radius: 0.625rem;
  border: 1px solid #eaebf1;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(101, 101, 101, 0.05);
  transition: all 500ms;
  cursor: pointer;
  overflow: hidden;

  &:hover {
    width: auto;
    border-color: #e15f2b;
  }
}

.name {
  color: #e15f2b;
  font-family: "Roboto";
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>
